import React from 'react';

const Footer = ({ motto }) => {
  return (
    <footer className="footer-main">
      <div className="footer-container">
        <div className="footer-motto">
          <h3 className="footer-motto-text">{motto}</h3>
        </div>
        
        <div className="footer-content">
          <div className="footer-section">
            <h4 className="footer-heading">Dr. Subhashini G</h4>
            <p className="footer-text">
              Advocate | Telangana High Court Bar
            </p>
            <p className="footer-text">
              Telangana State President, Human Rights Council
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Campaign 2026</h4>
            <p className="footer-text">
              Telangana Bar Council Elections
            </p>
            <p className="footer-text">
              Standing with you. Speaking for you.
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2026 Dr. Subhashini G Campaign. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
